'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTranslate = require('@gandi/react-translate');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = require('ramda');

var _classname = require('classname');

var _classname2 = _interopRequireDefault(_classname);

var _getShopData2 = require('../../shared/getShopData');

var _getShopData3 = _interopRequireDefault(_getShopData2);

var _sortAddressData = require('../../shared/sortAddressData');

var _sortAddressData2 = _interopRequireDefault(_sortAddressData);

var _FormTextfield = require('../FormTextfield/FormTextfield');

var _FormTextfield2 = _interopRequireDefault(_FormTextfield);

require('./Share.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requiredFields = ['lastname', 'firstname', 'email', 'conditions'];

var Share = function (_Component) {
  (0, _inherits3.default)(Share, _Component);

  function Share(props) {
    (0, _classCallCheck3.default)(this, Share);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Share.__proto__ || (0, _getPrototypeOf2.default)(Share)).call(this, props));

    _this.state = {
      lastname: '',
      firstname: '',
      email: '',
      comment: '',
      valid: '',
      conditions: false,
      hasError: false,
      errorTypes: [],
      errorFields: []
    };
    return _this;
  }

  (0, _createClass3.default)(Share, [{
    key: 'isEmailValid',
    value: function isEmailValid(value) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(value.toLowerCase());
    }
  }, {
    key: 'isValid',
    value: function isValid() {
      var areRequiredFieldsValid = (0, _ramda.pipe)((0, _ramda.mapObjIndexed)(function (value, key) {
        return requiredFields.indexOf(key) === -1 ? true : value;
      }), _ramda.values, (0, _ramda.all)(_ramda.identity))(this.state);
      return areRequiredFieldsValid && this.isEmailValid(this.state.email);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(field, value) {
      this.setState((0, _defineProperty3.default)({}, field, value));
      this.state.hasError && this.setErrors();
    }
  }, {
    key: 'handleEventValueChange',
    value: function handleEventValueChange(field, event) {
      this.handleChange(field, event.target.value);
    }
  }, {
    key: 'handleEventCheckedChange',
    value: function handleEventCheckedChange(field, event) {
      this.handleChange(field, event.target.checked);
    }
  }, {
    key: 'getRequiredErrors',
    value: function getRequiredErrors(state) {
      return (0, _ramda.pipe)((0, _ramda.mapObjIndexed)(function (value, key) {
        return requiredFields.indexOf(key) === -1 ? false : value ? false : key;
      }), _ramda.values, (0, _ramda.reduce)(function (acc, key) {
        return key ? acc.concat(key) : acc;
      }, []))(state);
    }
  }, {
    key: 'setErrors',
    value: function setErrors() {
      var _this2 = this;

      this.setState(function (prevState) {
        var errorTypes = [];
        var errorFields = _this2.getRequiredErrors(prevState);
        var isEmailValid = _this2.isEmailValid(prevState.email);
        errorFields.length > 0 && errorTypes.push(_this2.props.__('Form|Required fields'));
        if (!isEmailValid) {
          errorTypes.push(_this2.props.__('Form|Invalid E-mail address'));
          errorFields.push('email');
        }
        return { errorFields: errorFields, errorTypes: errorTypes };
      });
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(event) {
      event.preventDefault();

      if (this.isValid()) {
        var state = (0, _assign2.default)({}, this.state, {
          posId: this.props.shop.id,
          countryCode: this.props.countryCode,
          language: this.props.lang.toUpperCase(),
          locale: this.props.locale
        });

        delete state.errorFields;
        delete state.errorTypes;
        delete state.hasError;
        delete state.conditions;

        this.props.submitCallback(state, this.confirmation);
        this.setState({ hasError: false });
      } else {
        this.setState({ hasError: true });
      }
      this.setErrors();
    }
  }, {
    key: 'render',
    value: function render() {
      var __ = this.props.__;

      var _getShopData = (0, _getShopData3.default)(this.props.shop, this.props.countryCode),
          shopName = _getShopData.shopName,
          shopStreet = _getShopData.shopStreet,
          shopStreet1 = _getShopData.shopStreet1,
          shopZipCode = _getShopData.shopZipCode,
          shopCity = _getShopData.shopCity,
          shopState = _getShopData.shopState,
          countryCode = _getShopData.countryCode;

      this.shopName = shopName;
      this.shopStreet = shopStreet;
      this.shopStreet1 = shopStreet1;
      this.shopZipCode = shopZipCode;
      this.shopCity = shopCity;
      this.countryCode = countryCode;
      var brand = this.props.brand;
      var address = this.props.shop && (0, _sortAddressData2.default)(this.props.locale, this.countryCode, this.shopZipCode, this.shopCity, this.shopStreet, this.shopStreet1, shopState, this.shopName);

      this.confirmation = _react2.default.createElement(
        'div',
        { className: 'text-center' },
        _react2.default.createElement(
          'h3',
          { className: 'Share__title' },
          __('Share|Share this shop')
        ),
        _react2.default.createElement(
          'div',
          null,
          __('Share|Share Confirmation')
        )
      );

      return _react2.default.createElement(
        'div',
        { className: 'Share' },
        _react2.default.createElement(
          'div',
          { className: 'container-fluid' },
          _react2.default.createElement(
            'h3',
            { className: 'Share__title' },
            __('Share|Share this shop')
          ),
          _react2.default.createElement(
            'div',
            { className: 'Share__desc' },
            __('Share|Your favorite shop'),
            ' :'
          ),
          _react2.default.createElement(
            'form',
            { onSubmit: this.onSubmit.bind(this), noValidate: true },
            address && address.length > 0 && _react2.default.createElement(
              'ul',
              { className: 'Share__address' },
              address.map(function (line, index) {
                return line && line.length > 0 && _react2.default.createElement(
                  'li',
                  { key: index },
                  line
                );
              })
            ),
            _react2.default.createElement(
              'fieldset',
              { className: 'Share__fieldset' },
              _react2.default.createElement(
                'legend',
                { className: 'Share__legend' },
                __('Share|Recipient'),
                ' :'
              ),
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { className: 'Share__col Share__col--left col-lg-6' },
                  _react2.default.createElement(
                    'div',
                    { className: 'Share__field' },
                    _react2.default.createElement(_FormTextfield2.default, {
                      fullWidth: true,
                      required: requiredFields.indexOf('lastname') !== -1,
                      name: 'share-lastname',
                      id: 'share-lastname',
                      placeholder: __('Form|Name'),
                      label: __('Form|Name'),
                      onChange: this.handleChange.bind(this, 'lastname'),
                      value: this.state.lastname,
                      error: this.state.errorFields.indexOf('lastname') !== -1
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'Share__field' },
                    _react2.default.createElement(_FormTextfield2.default, {
                      fullWidth: true,
                      required: requiredFields.indexOf('firstname') !== -1,
                      name: 'share-firstname',
                      id: 'share-firstname',
                      placeholder: __('Form|Surname'),
                      label: __('Form|Surname'),
                      onChange: this.handleChange.bind(this, 'firstname'),
                      value: this.state.firstname,
                      error: this.state.errorFields.indexOf('firstname') !== -1
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'Share__field' },
                    _react2.default.createElement(_FormTextfield2.default, {
                      fullWidth: true,
                      required: requiredFields.indexOf('email') !== -1,
                      name: 'share-email',
                      id: 'share-email',
                      placeholder: __('Form|Email'),
                      label: __('Form|Email'),
                      onChange: this.handleChange.bind(this, 'email'),
                      value: this.state.email,
                      error: this.state.errorFields.indexOf('email') !== -1
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'Share__col Share__col--right col-lg-6' },
                  _react2.default.createElement(
                    'div',
                    { className: (0, _classname2.default)('Share__field Share__comments', { 'is-required': requiredFields.indexOf('comment') !== -1, 'has-error': this.state.errorFields.indexOf('comment') !== -1 }) },
                    _react2.default.createElement(
                      'label',
                      { htmlFor: 'share-comments', className: 'form__label' },
                      __('Form|Comments')
                    ),
                    _react2.default.createElement('textarea', {
                      className: 'form__input',
                      name: 'share-comments',
                      id: 'share-comments',
                      placeholder: __('Form|Comments'),
                      onChange: this.handleEventValueChange.bind(this, 'comment'),
                      required: requiredFields.indexOf('comment') !== -1,
                      value: this.state.comment
                    })
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row row-margin-top' },
              _react2.default.createElement(
                'div',
                { className: 'Share__conditions Share__col col-lg-8' },
                _react2.default.createElement(
                  'div',
                  { className: (0, _classname2.default)('form__input--checkbox', { 'is-required': requiredFields.indexOf('conditions') !== -1, 'has-error': this.state.errorFields.indexOf('conditions') !== -1 }) },
                  _react2.default.createElement('input', {
                    required: requiredFields.indexOf('conditions') !== -1,
                    name: 'share-conditions',
                    id: 'share-conditions',
                    type: 'checkbox',
                    className: 'sr-only',
                    onClick: this.handleEventCheckedChange.bind(this, 'conditions'),
                    checked: this.state.conditions
                  }),
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'share-conditions', className: 'form__label' },
                    __('Share|Conditions', { brand: brand })
                  ),
                  _react2.default.createElement('input', {
                    tabIndex: '-1',
                    autoComplete: 'new-password',
                    type: 'text',
                    id: 'share-valid',
                    name: 'share-valid',
                    className: 'sr-only',
                    onChange: this.handleEventValueChange.bind(this, 'valid'),
                    value: this.state.valid
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'Share__col Share__col-submit col-lg-4' },
                _react2.default.createElement(
                  'div',
                  { className: 'Share__errors' },
                  this.state.errorTypes.length > 0 && _react2.default.createElement(
                    'ul',
                    null,
                    this.state.errorTypes.map(function (error, key) {
                      return _react2.default.createElement(
                        'li',
                        { key: key },
                        error
                      );
                    })
                  )
                ),
                _react2.default.createElement('input', {
                  type: 'submit',
                  className: 'Share__submit button button--dark',
                  value: __('Form|Submit')
                })
              )
            )
          )
        )
      );
    }
  }]);
  return Share;
}(_react.Component);

Share.propTypes = {
  __: _propTypes2.default.func.isRequired, // @see https://github.com/Gandi/react-translate
  brand: _propTypes2.default.string,
  countryCode: _propTypes2.default.string,
  lang: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  shop: _propTypes2.default.object,
  submitCallback: _propTypes2.default.func
};

Share.defaultProps = {
  brand: 'Christian Dior Couture',
  countryCode: 'INT',
  lang: 'en',
  locale: 'en_int',
  shop: null,
  submitCallback: function submitCallback() {}
};

exports.default = (0, _reactTranslate.withTranslator)()(Share);


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/components/Share/Share.js
// module id = 1176
// module chunks = 0